import { useEffect } from 'react'

/**
 * Sets the browser tab title for whatever screen is currently mounted.
 *
 * Every screen calls this with its own heading, composed against the brand
 * name — see `titleFor` in `screens/NodeScreen.tsx` and the two call sites in
 * `App.tsx`. No cleanup/reset on unmount: `<main key={location.pathname}>` in
 * Layout.tsx already remounts the whole screen tree on every navigation, so the
 * next screen's own call overwrites this one before a stale title could ever
 * be seen.
 */
export function useDocumentTitle(title: string): void {
	useEffect(() => {
		document.title = title
	}, [title])
}
